import React, { useEffect, useState } from 'react'
import { useAuthStore } from '../../../store/authStore'
import { auth, db } from '../../../services/firebase'
import { sendPasswordResetEmail, updateProfile } from 'firebase/auth'
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import Button from '../../../components/common/Button'
import LoadingSpinner from '../../../components/common/LoadingSpinner'

function SettingsPage() {
  const { user } = useAuthStore()
  const [profile, setProfile] = useState(null)
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const run = async () => {
      if (!user?.uid || !db) {
        setLoading(false)
        return
      }
      try {
        const snap = await getDoc(doc(db, 'users', user.uid))
        setProfile(snap.exists() ? snap.data() : {})
      } catch (e) {
        setError('No se pudo cargar tu perfil')
      } finally {
        setLoading(false)
      }
    }
    run()
  }, [user?.uid])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64"><LoadingSpinner size="large" /></div>
    )
  }

  const created = profile.createdAt?.toDate ? profile.createdAt.toDate() : (profile.createdAt ? new Date(profile.createdAt) : null)
  const activated = profile.activatedAt?.toDate ? profile.activatedAt.toDate() : (profile.activatedAt ? new Date(profile.activatedAt) : null)

  const onSave = async () => {
    setSaving(true)
    try {
      await updateDoc(doc(db, 'users', user.uid), { displayName: profile.displayName })
      if (auth?.currentUser) {
        await updateProfile(auth.currentUser, { displayName: profile.displayName || '' })
      }
    } finally {
      setSaving(false)
    }
  }

  const onResetPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, profile.email)
    } catch {}
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Perfil</h1>
        {error && <p className="text-sm text-red-600 mb-4">{error}</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
            <input className="w-full border rounded-md px-3 py-2" value={profile.displayName || ''} onChange={(e) => setProfile({ ...profile, displayName: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Correo</label>
            <input className="w-full border rounded-md px-3 py-2" value={profile.email || ''} readOnly />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Plan</label>
            <input className="w-full border rounded-md px-3 py-2" value={profile.plan || 'free'} readOnly />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Máx. Dkards</label>
            <input className="w-full border rounded-md px-3 py-2" value={typeof profile.maxCards === 'number' ? profile.maxCards : 1} readOnly />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Fecha de registro</label>
            <input className="w-full border rounded-md px-3 py-2" value={created ? created.toLocaleDateString() : ''} readOnly />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Fecha de habilitación</label>
            <input className="w-full border rounded-md px-3 py-2" value={activated ? activated.toLocaleDateString() : ''} readOnly />
          </div>
        </div>
        <div className="mt-6">
          <Button variant="primary" loading={saving} onClick={onSave}>Guardar</Button>
          <Button variant="secondary" className="ml-3" onClick={onResetPassword}>Cambiar contraseña</Button>
        </div>
      </div>
    </div>
  )
}

export default SettingsPage
